export const AD_PLACEMENTS = {
  SIDEBAR: {
    DESKTOP_LEFT: "left",
  },
  LIST_VIEW: {
    AFTER_EVERY_5_RECORDS: `banner ad (6th tile`,
    BOTTOM: "bottom",
  },

  MOBILE: "mobile",
  GRID_VIEW: {
    GRID_6TH_TILE: "banner ad mobile/grid view (6th tile",
  },
};
